import { BrowserRouter as Router } from "react-router-dom";
import { HFCRoutes } from "./routes/Routes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
const queryClient = new QueryClient();

function App() {
  return (
    <Router>
      <QueryClientProvider client={queryClient}>
        <HFCRoutes />
      </QueryClientProvider>
    </Router>
  );
}

export default App;
